import { createContext, useState, useEffect } from "react";
import jwt_decode from "jwt-decode";
import { useHistory } from "react-router-dom";
import { BASE_URL, LOGIN, REFRESH, LOGOUT } from "../Constants";
import SweetAlert from "../utils/SweetAlert";

const AuthContext = createContext();

export default AuthContext;

export const AuthProvider = ({ children }) => {
	const [authTokens, setAuthTokens] = useState(() =>
		localStorage.getItem("authTokens")
			? JSON.parse(localStorage.getItem("authTokens"))
			: null
	);
	const [user, setUser] = useState(() => {
    const tokens =
        localStorage.getItem("authTokens");

    return tokens
        ? jwt_decode(
              JSON.parse(tokens).access
          )
        : null;
});
	const [loading, setLoading] = useState(true);
	const [isClicked, setIsClicked] = useState(false);

	const history = useHistory();

	const loginUser = async (e) => {
		e.preventDefault();
		const response = await fetch(BASE_URL + LOGIN, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				email: e.target.email.value,
				password: e.target.password.value,
			}),
		});
		const data = await response.json();

		if (response.status === 200) {

    localStorage.setItem(
        "authTokens",
        JSON.stringify(data)
    );

    setAuthTokens(data);

    setUser(
        jwt_decode(data.access)
    );

    setIsClicked(false);

    window.location.href = "/";
		} else {
			// alert("Something went wrong!");
			SweetAlert({ title: "Something went wrong", icon: "error" });
		}
	};

	// const handleClick = () => {
	// 	setIsClicked(!isClicked);
	// };
	//Original code
	const handleClick = () => {
	setIsClicked((prev) => !prev); //changed by Sakthi
};
	const logoutapi = async () => {
		const authTokens = JSON.parse(localStorage.getItem("authTokens"));
		const accessToken = authTokens?.access;

		if (!accessToken) {
			console.error("No access token found");
			return;
		}

		const decodedToken = jwt_decode(accessToken);
		const userId = decodedToken.user_id; // Assuming 'user_id' is a claim in the token

		const response = await fetch(BASE_URL + LOGOUT, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${accessToken}`, // Include the token in the header
			},
			body: JSON.stringify({ user_id: userId }), // Include the user_id in the body
		});
	};
	const logoutUser = () => {
		logoutapi();

		setAuthTokens(null);
		setUser(null);
		localStorage.removeItem("authTokens");
		// setIsClicked(!isClicked);//Original code
		setIsClicked(false);//changed by Sakthi
		history.push("/login");
	};

	const updateToken = async () => {
		const response = await fetch(BASE_URL + REFRESH, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ refresh: authTokens?.refresh }),
		});

		const data = await response.json();

		if (response.status === 200) {
			setAuthTokens(data);
			setUser(jwt_decode(data.access));
			localStorage.setItem("authTokens", JSON.stringify(data));
		} else {
			logoutUser();
		}

		if (loading) {
			setLoading(false);
		}
	};

	const contextData = {
		user: user,
		authTokens: authTokens,
		loginUser: loginUser,
		logoutUser: logoutUser,
		isClicked: isClicked,
		setIsClicked: setIsClicked,
		handleClick: handleClick,
	};

	useEffect(() => {
		if (loading) {
			updateToken();
		}

		const fourMinutes = 1000 * 60 * 4;

		const interval = setInterval(() => {
			if (authTokens) {
				updateToken();
			}
		}, fourMinutes);
		return () => clearInterval(interval);
	}, [authTokens, loading]);

	return (
		<AuthContext.Provider value={contextData}>
			{loading ? null : children}
		</AuthContext.Provider>
	);
};
